import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnInit,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import {
  NameFilter,
  StripeService,
  CompanyService,
  DataSyncService,
} from '@ops/shared-types';
import { Observable, Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ops-completed-projects-stats',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './ops-completed-projects-stats.component.html',
  styleUrl: './ops-completed-projects-stats.component.scss',
})
export class OpsCompletedProjectsStats implements OnInit, OnChanges, OnDestroy {
  @Input() selectedCompanyId: string;

  stripeSubs: Subscription;
  dataSyncSub: Subscription;
  completedProjectsCount: number = 0;
  isLoading: boolean = true;
  selectedCompany$: Observable<NameFilter>;

  constructor(
    private stripeService: StripeService, 
    private companyService: CompanyService,
    private dataSyncService: DataSyncService
  ) {
    // this.selectedCompany$ = this.sessionService.getUser$;
  }

  ngOnInit(): void {
    // Subscribe to data sync refetch events to update completed projects count
    this.dataSyncSub = this.dataSyncService.getRefetchVersionListener().subscribe((version) => {
      if (version > 0 && this.selectedCompanyId) {
        // Trigger refetch of completed projects count when data sync event occurs
        this.getCompletedProjectsCount();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.stripeSubs?.unsubscribe) {
      this.stripeSubs.unsubscribe();
    }
    if (this.dataSyncSub?.unsubscribe) {
      this.dataSyncSub.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.stripeSubs?.unsubscribe) {
      this.stripeSubs.unsubscribe();
    }

    if (
      (changes.selectedCompanyId?.previousValue !==
        changes.selectedCompanyId.currentValue) ||
      (changes.projectId?.previousValue !== changes.projectId.currentValue)
    ) {
      this.isLoading = true;
      this.getCompletedProjectsCount();
    }
  }

  private getCompletedProjectsCount(): void {
    if (!this.selectedCompanyId) {
      return;
    }

    this.stripeSubs = this.companyService.getCompanyAdditionalInfo(this.selectedCompanyId)
      .subscribe((response: any) => {
        // Assuming the response contains completed projects count
        // You may need to adjust the property name based on the actual API response structure
        this.completedProjectsCount = response.distinctCompletedProjects || 0;
        this.isLoading = false;
      }, (error) => {
        console.error('Error fetching completed projects count:', error);
        this.completedProjectsCount = 0;
        this.isLoading = false;
      });
  }
}
